// extracted by mini-css-extract-plugin
module.exports = {"dot-flashing":"styles_dot-flashing__-KVGY","dotFlashing":"styles_dotFlashing__2IyfO"};